export { default as ScrollSync } from './ScrollSync'
export { default as ScrollSyncPane } from './ScrollSyncPane'



// WEBPACK FOOTER //
// ./src/index.js